// Parser mínimo do WKT que o Traccar usa em Geofence.area (sempre CIRCLE ou
// POLYGON — não existe um tipo "retângulo" nativo no Traccar). Extraído de
// src/routes/geofences.tsx para ser reaproveitado também pelo mapa
// principal, sem duplicar a lógica de parsing.
export interface ParsedCircle {
  lat: number;
  lng: number;
  radius: number;
}

export interface ParsedPolygon {
  points: { lat: number; lng: number }[];
}

export function parseWkt(
  wkt: string,
): { type: "circle"; data: ParsedCircle } | { type: "polygon"; data: ParsedPolygon } | null {
  const circle = wkt.match(/^\s*CIRCLE\s*\(\s*([-\d.]+)\s+([-\d.]+)\s*,\s*([\d.]+)\s*\)\s*$/i);
  if (circle) {
    const [, lng, lat, radius] = circle;
    return { type: "circle", data: { lat: Number(lat), lng: Number(lng), radius: Number(radius) } };
  }
  const polygon = wkt.match(/^\s*POLYGON\s*\(\((.+)\)\)\s*$/i);
  if (polygon) {
    const points = polygon[1]
      .split(",")
      .map((pair) => {
        const [lng, lat] = pair.trim().split(/\s+/).map(Number);
        return { lat, lng };
      })
      .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
    return { type: "polygon", data: { points } };
  }
  return null;
}
